import React from 'react';
import { useToast } from '../context/ToastContext';
import '../styles/toast.css';

const ToastViewport = () => {
  const { toast, hideToast } = useToast();

  if (!toast) return null;

  return (
    <div className="toast-viewport" aria-live="polite" aria-atomic="true">
      <div className={`toast-card ${toast.tone}`}>
        <span>{toast.message}</span>
        <button type="button" className="toast-close" onClick={hideToast} aria-label="Закрыть уведомление">
          ×
        </button>
      </div>
    </div>
  );
};

export default ToastViewport;
